export const extractPermissionNames = (permissions: { permission_name: string }[]): string[] => {
    return permissions.map(permission => permission.permission_name);
};
